import { useState, useEffect } from 'react';
import './Navbar.css';
import { useAuth } from '@/contexts/AuthContext';

const programsMenu = [
  { label: 'SAT Prep', to: '/sat-prep' },
  { label: 'ACT Prep', to: '/act-prep' },
  { label: 'AP Subjects', to: '/ap-physics' },
  { label: 'Subject Tutoring', to: '/subject-tutoring' },
  { label: 'ELA Mastery Program', to: '/english-tutoring' },
  { label: 'College Counseling & Essays', to: '/college-counseling' },
];

const aboutMenu = [
  { label: 'About Us', to: '/about' },
  { label: 'Meet our tutors', to: '/tutors' },
  { label: 'Success Stories', to: '/reviews' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [programsOpen, setProgramsOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const path = window.location.pathname;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo(0, 0);
  }, [path]);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-container container">
        <a href="/" className="nav-logo">
          <img
            src="/logo.svg"
            alt="Scholar Sphere"
            className="logo-img"
          />
        </a>

        <ul className="nav-links">
          <li><a href="/">Home</a></li>

          <li
            className="has-dropdown"
            onMouseEnter={() => setProgramsOpen(true)}
            onMouseLeave={() => setProgramsOpen(false)}
          >
            <a href="#">Programs <span className="chevron">&#9660;</span></a>
            {programsOpen && (
              <div className="dropdown">
                {programsMenu.map(item => (
                  <a key={item.label} href={item.to}>{item.label}</a>
                ))}
              </div>
            )}
          </li>

          <li
            className="has-dropdown"
            onMouseEnter={() => setAboutOpen(true)}
            onMouseLeave={() => setAboutOpen(false)}
          >
            <a href="#">About <span className="chevron">&#9660;</span></a>
            {aboutOpen && (
              <div className="dropdown">
                {aboutMenu.map(item => (
                  <a key={item.label} href={item.to}>{item.label}</a>
                ))}
              </div>
            )}
          </li>

          <li><a href="/contact">Contact Us</a></li>
        </ul>

        <div className="nav-actions">
          {isAuthenticated ? (
            <a href="/dashboard" className="nav-login">Dashboard</a>
          ) : (
            <a href="/login" className="nav-login">Log in</a>
          )}
          <a href="/signup" className="btn-gold nav-cta">START PRACTICING FOR FREE</a>
        </div>

        <button className="hamburger" onClick={() => setMobileOpen(v => !v)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>

      {mobileOpen && (
        <div className="mobile-menu">
          <a href="/">Home</a>
          <div className="mob-group-label">Programs</div>
          {programsMenu.map(item => <a key={item.label} href={item.to} className="mob-sub">{item.label}</a>)}
          <div className="mob-group-label">About</div>
          {aboutMenu.map(item => <a key={item.label} href={item.to} className="mob-sub">{item.label}</a>)}
          <a href="/contact">Contact Us</a>
          {isAuthenticated ? (
            <a href="/dashboard" className="mob-login">Dashboard</a>
          ) : (
            <a href="/login" className="mob-login">Log in</a>
          )}
          <a href="/signup" className="btn-gold mob-cta">START PRACTICING FOR FREE</a>
        </div>
      )}
    </nav>
  );
}
